import { Action, createReducer, on } from '@ngrx/store';

import * as actions from '@upsell/store/actions/upsell.actions';

export const initialState = false;

const featureReducer = createReducer(
  initialState,
  on(
    actions.fetchUpsellOptionsAction,
    actions.fetchUpsellOptionsBySectorAction,
    actions.fetchPackageUpsellOptionsAction,
    () => true
  ),
  on(
    actions.fetchUpsellOptionsSuccessAction,
    actions.fetchUpsellOptionsErrorAction,
    actions.fetchUpsellOptionsErrorBySectorAction,
    actions.fetchPackageUpsellOptionsSuccessAction,
    actions.fetchPackageUpsellOptionsErrorAction,
    () => initialState
  ),
);

export const isLoadingUpsellReducer = (state: boolean, action: Action): boolean => {
  return featureReducer(state, action);
};
